import { Environment } from '@abp/ng.core';

const baseUrl = 'https://training-tracking-staging.upmuruguay.net';

const oAuthConfig = {
  issuer: 'https://training-tracking-backend-staging.upmuruguay.net/',
  redirectUri: baseUrl,
  clientId: 'TrainingTracking_App',
  responseType: 'code',
  scope: 'offline_access TrainingTracking',
  requireHttps: true,
};

export const environment = {
  name: 'staging',
  production: false,
  useServiceWorker: true,
  application: {
    baseUrl,
    name: 'TrainingTracking',
  },
  oAuthConfig,
  impersonation: {
    tenantImpersonationEnabled: true,
    userImpersonationEnabled: true,
  },
  apis: {
    default: {
      url: 'https://training-tracking-backend-staging.upmuruguay.net',
      rootNamespace: 'Upm.TrainingTracking',
    },
    AbpAccountPublic: {
      url: oAuthConfig.issuer,
      rootNamespace: 'AbpAccountPublic',
    },
  },
  appVersion: '0.0.1',
  grafana: {
    isEnabled: false,
    url: 'https://faro-collector-prod-sa-east-1.grafana.net/collect/6039e1fdcb922efed600b19219f01c9b',
  },
} as Environment;
